import React, { Component } from "react"
import { Link } from "gatsby"

import {
  Collapse,
  NavItem,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  Dropdown,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap"
import "./index.css"

class NavBar extends Component {
  constructor(props) {
    super(props)
    this.toggle = this.toggle.bind(this)
    this.dropToggle = this.dropToggle.bind(this)
    this.onMouseEnter = this.onMouseEnter.bind(this)
    this.onMouseLeave = this.onMouseLeave.bind(this)
    this.state = {
      isOpen: false,
      dropdownOpen: false,
    }
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen,
    })
  }

  dropToggle() {
    this.setState(prevState => ({
      dropdownOpen: !prevState.dropdownOpen,
    }))
  }

  onMouseEnter() {
    this.setState({ dropdownOpen: true })
  }

  onMouseLeave() {
    this.setState({ dropdownOpen: false })
  }

  render() {
    return (
      <header id="ts-header" className="fixed-top">
        <div className="container">
          <Navbar className="my-navbar pt-4" dark expand="lg">
            <NavbarBrand href="/" className="">
              <img
                className="img-fluid logo"
                src={require("../../../images/taxi-on-spot-logo.png")}
              />
            </NavbarBrand>
            <NavbarToggler onClick={this.toggle} className="text-light" />
            <Collapse isOpen={this.state.isOpen} navbar>
              <Nav className="ml-auto" navbar>
                <NavItem className="pl-md-4">
                  <Link className="text-white nav-link navbar-link" to="/">
                    Airport Transportation
                  </Link>
                </NavItem>
                <NavItem className="pl-md-4">
                  <Link className="text-white nav-link navbar-link" to="/about">
                    About us
                  </Link>
                </NavItem>
                <UncontrolledDropdown
                  className="d-inline-block pl-md-4"
                  onMouseOver={this.onMouseEnter}
                  onMouseLeave={this.onMouseLeave}
                  isOpen={this.state.dropdownOpen}
                  toggle={this.dropToggle}
                >
                  <DropdownToggle
                    className="ts-lang-dropdown text-white nav-link navbar-link "
                    href="/"
                    caret
                  >
                    ENG
                  </DropdownToggle>
                  <DropdownMenu>
                    <DropdownItem href="/">DE</DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>
              </Nav>
            </Collapse>
          </Navbar>
        </div>
      </header>
    )
  }
}

export default NavBar
